import type { RechargeRecord } from './types';

export const mockRechargeRecords: RechargeRecord[] = [
  {
    id: '1',
    rechargeId: 'RC202501150001',
    orderNo: 'ORD202501150001',
    rechargeType: '充值',
    userType: '企业',
    userId: 'U10001',
    userName: '张三',
    rechargeAmount: 10000,
    convertedPoints: 0,
    giftAmount: 500,
    actualAmount: 10000,
    rechargeMethod: '用户充值',
    paymentMethod: '微信支付',
    operatorId: 'U10001',
    operatorName: '张三',
    rechargeTime: '2025-01-15 10:30:25',
  },
  {
    id: '2',
    rechargeId: 'RC202501150002',
    orderNo: 'ORD202501150002',
    rechargeType: '充值',
    userType: '学校',
    userId: 'U10002',
    userName: '李四',
    rechargeAmount: 50000,
    convertedPoints: 50000,
    giftAmount: 5000,
    actualAmount: 50000,
    rechargeMethod: '后台充值',
    paymentMethod: '后台支付',
    operatorId: 'A10001',
    operatorName: '管理员王五',
    rechargeTime: '2025-01-15 11:20:15',
  },
  {
    id: '3',
    rechargeId: 'RC202501150003',
    orderNo: 'ORD202501150003',
    rechargeType: '充值',
    userType: '个人',
    userId: 'U10003',
    userName: '王小明',
    rechargeAmount: 5000,
    convertedPoints: 0,
    giftAmount: 0,
    actualAmount: 5000,
    rechargeMethod: '用户充值',
    paymentMethod: '支付宝支付',
    operatorId: 'U10003',
    operatorName: '王小明',
    rechargeTime: '2025-01-15 14:45:30',
  },
  {
    id: '4',
    rechargeId: 'RC202501150004',
    orderNo: 'ORD202501150004',
    rechargeType: '红冲',
    userType: '企业',
    userId: 'U10001',
    userName: '张三',
    rechargeAmount: -10000,
    convertedPoints: 0,
    giftAmount: -500,
    actualAmount: -10000,
    rechargeMethod: '后台充值',
    paymentMethod: '后台支付',
    operatorId: 'A10001',
    operatorName: '管理员王五',
    rechargeTime: '2025-01-15 15:10:20',
  },
  {
    id: '5',
    rechargeId: 'RC202501150005',
    orderNo: 'ORD202501150005',
    rechargeType: '充值',
    userType: '企业',
    userId: 'U10004',
    userName: '赵六',
    rechargeAmount: 20000,
    convertedPoints: 0,
    giftAmount: 1000,
    actualAmount: 20000,
    rechargeMethod: '用户充值',
    paymentMethod: '微信支付',
    operatorId: 'U10004',
    operatorName: '赵六',
    rechargeTime: '2025-01-15 16:25:40',
  },
  {
    id: '6',
    rechargeId: 'RC202501150006',
    orderNo: 'ORD202501150006',
    rechargeType: '退款',
    userType: '个人',
    userId: 'U10003',
    userName: '王小明',
    rechargeAmount: -5000,
    convertedPoints: 0,
    giftAmount: 0,
    actualAmount: -5000,
    rechargeMethod: '后台充值',
    paymentMethod: '后台支付',
    operatorId: 'A10001',
    operatorName: '管理员王五',
    rechargeTime: '2025-01-15 17:30:15',
  },
  {
    id: '7',
    rechargeId: 'RC202501140001',
    orderNo: 'ORD202501140001',
    rechargeType: '充值',
    userType: '学校',
    userId: 'U10005',
    userName: '孙七',
    rechargeAmount: 100000,
    convertedPoints: 100000,
    giftAmount: 10000,
    actualAmount: 100000,
    rechargeMethod: '后台充值',
    paymentMethod: '后台支付',
    operatorId: 'A10002',
    operatorName: '管理员李明',
    rechargeTime: '2025-01-14 09:15:30',
  },
  {
    id: '8',
    rechargeId: 'RC202501140002',
    orderNo: 'ORD202501140002',
    rechargeType: '充值',
    userType: '个人',
    userId: 'U10006',
    userName: '周八',
    rechargeAmount: 1000,
    convertedPoints: 0,
    giftAmount: 0,
    actualAmount: 1000,
    rechargeMethod: '用户充值',
    paymentMethod: '支付宝支付',
    operatorId: 'U10006',
    operatorName: '周八',
    rechargeTime: '2025-01-14 13:40:25',
  },
];
